import { createContext, useContext } from "react";

export const AuthTokenContext = createContext<string | null>(null);
export const useAuthToken = () => {
    return useContext(AuthTokenContext);
};
